import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Hurdapartymorachichincholi() {



    const cardData =
    {
        keyword: 'Hurda Party Morachi Chincholi',
        heading: 'Anand Krushi Paryatan Kendra: Hurda Party Morachi Chincholi',
        headingDescription: 'Celebrate the festive spirit with a traditional hurda party at Anand Krushi Paryatan Kendra, the perfect Hurda Party Morachi Chincholi venue just 55 km from Pune. Nestled on a 40-acre farm in Morachi Chincholi, this agri-tourism gem combines village warmth with festive fun in a serene eco-friendly setting. Experience the joy of hurda (puffed barnyard millet) cooked fresh on-site, surrounded by lush fields and cheerful company. The farm elevates your celebration with engaging activities—bullock cart and tractor rides, horse riding, boating, swimming, refreshing rain-dance, traditional village games, puppet shows, and magic performances.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Traditional Hurda Party Feast",
    "description": "Enjoy freshly roasted green jowar (hurda) served hot with chutneys, curd, jaggery, garlic thecha, and seasonal vegetables. The party is hosted in open-air farm areas where you sit on mats or charpai and eat like a local – simple, flavorful, and unforgettable."
  },
  {
    "title": "Live Folk Music & Dholki Fun",
    "description": "Most Hurda parties include traditional dholki music, lavani, bhajans, or kirtan. Join in the singing, clapping, or even a quick round of lezim or fugdi – perfect for adding joy to your rustic food experience."
  },
  {
    "title": "Farm Activities & Bullock Cart Rides",
    "description": "Before or after the meal, you can enjoy rural games, nature walks, feeding farm animals, or taking a bullock cart ride through sugarcane and mustard fields — great fun for kids and elders alike."
  },
  {
    "title": "Agro-Tourism Add-Ons",
    "description": "Combine your Hurda Party with other attractions at Anand Krushi Paryatan Kendra or similar farms — pottery workshops, tractor safaris, splash pool, rain dance, and interactive dairy experiences."
  },
  {
    "title": "Peacock Watching at Sunrise",
    "description": "Reach early morning and you might spot dozens of peacocks dancing in the fields of Morachi Chincholi — a rare and serene rural sight that sets the perfect tone for the day."
  }
],




"services": [
  {
    "name": "Seasonal Hurda Parties Near Morachi Chincholi",
    "description": "Celebrate the winter harvest season with traditional hurda parties at Anand Krushi Paryatan Kendra. Enjoy freshly roasted green jowar, surrounded by farms and festive vibes—perfect for families, groups, and nature lovers."
  },
  {
    "name": "Farm-Based Hurda Events",
    "description": "Experience an authentic hurda party on the farm where the jowar is harvested, roasted, and served fresh. Anand Krushi Paryatan Kendra brings you closer to rural roots with hands-on activities and real-time farm-to-plate experiences."
  },
  {
    "name": "Hurda Party with Folk Music",
    "description": "Join us for a cultural evening where the warmth of hurda is paired with the rhythm of live folk music and dhol-tasha performances, making your visit to Morachi Chincholi truly unforgettable."
  },
  {
    "name": "Traditional Maharashtrian Hurda Experiences",
    "description": "Indulge in the authentic taste of rural Maharashtra with traditional hurda served alongside chutneys, jaggery, thecha, and bhakri. Anand Krushi Paryatan Kendra recreates age-old traditions with a touch of hospitality."
  },
  {
    "name": "Group Hurda Parties in Morachi Chincholi",
    "description": "Planning a day out with friends or a group tour? Anand Krushi Paryatan Kendra organizes hurda parties for large groups with farm games, music, and customized meal setups in a scenic countryside setting."
  },
  {
    "name": "Hurda Party with Rural Games",
    "description": "Add fun to flavor with traditional rural games like lagori, tug-of-war, and sack races. Anand Krushi Paryatan Kendra blends food and play into an interactive farm experience during hurda season."
  },
  {
    "name": "Family-Friendly Hurda Outings",
    "description": "Families love our kid-safe environment and open spaces. Children can play, feed farm animals, and enjoy nature while parents relish delicious hurda and village-style hospitality—all in one location."
  },
  {
    "name": "Bonfire Hurda Party Options",
    "description": "Celebrate a rustic winter night with a bonfire hurda party. Gather around the warmth of the fire, enjoy roasted jowar, sing songs, and relax in the peaceful atmosphere of Morachi Chincholi."
  },
  {
    "name": "Organic Hurda Tasting Near Pune",
    "description": "Savor pesticide-free, naturally grown hurda freshly harvested from our own farm. At Anand Krushi Paryatan Kendra, we focus on organic farming and authentic rural flavors you can taste in every bite."
  },
  {
    "name": "Agro-Tourism Hurda Events",
    "description": "Join our seasonal agro-tourism hurda festivals where guests learn about jowar cultivation, participate in harvesting, and enjoy a full-day rural immersion experience complete with food and farm fun."
  },
  {
    "name": "Cultural Food Events in Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra regularly hosts seasonal food festivals where hurda is the star. Enjoy it with other local delicacies, folk performances, and a tour of the working farm."
  },
  {
    "name": "Weekend Hurda Trips from Pune",
    "description": "Escape Pune for a winter weekend of good food and rural charm. Just a short drive away, our hurda events offer a wholesome experience with countryside air, local cuisine, and plenty of family fun."
  },
  {
    "name": "Hurda Party with Kids Activities",
    "description": "Parents can enjoy fresh hurda while kids explore dedicated play zones, petting farms, and farm-themed games—making it a fun and interactive outing for the whole family."
  },
  {
    "name": "Affordable Hurda Party Packages",
    "description": "Enjoy a complete day-out hurda experience with meals, activities, and cultural elements at budget-friendly rates. Anand Krushi Paryatan Kendra offers packages for families, schools, and corporate groups."
  },
  {
    "name": "Farm Picnic with Hurda Theme",
    "description": "Bring your picnic blanket and spend a relaxing day surrounded by nature. Enjoy a hurda-themed meal, play games, and unwind under trees at our scenic picnic-ready farm setup."
  }
],
"tableData": [
  ["Seasonal Hurda Parties Near Morachi Chincholi", "- Farm-Based Hurda Events"],
  ["Hurda Party with Folk Music", "- Traditional Maharashtrian Hurda Experiences"],
  ["Group Hurda Parties in Morachi Chincholi", "- Hurda Party with Rural Games"],
  ["Family-Friendly Hurda Outings", "- Bonfire Hurda Party Options"],
  ["Organic Hurda Tasting Near Pune", "- Agro-Tourism Hurda Events"],
  ["Cultural Food Events in Morachi Chincholi", "- Weekend Hurda Trips from Pune"],
  ["Hurda Party with Kids Activities", "- Affordable Hurda Party Packages"],
  ["Farm Picnic with Hurda Theme", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Traditional Maharashtrian Celebration",
    "WhyChoosedescription": "Hurda Party is a unique winter harvest festival celebrated in Morachi Chincholi, where freshly harvested jowar (sorghum) is roasted over open flames. Visitors get to experience authentic rural Maharashtrian culture through food, music, and communal festivities."
  },
  {
    "WhyChooseheading": "Freshly Roasted Hurda Experience",
    "WhyChoosedescription": "Taste the freshly roasted sorghum served with traditional accompaniments like jaggery, lemon, green chilies, and chutneys. This simple yet flavorful dish connects guests directly to the agricultural roots and seasonal bounty of the region."
  },
  {
    "WhyChooseheading": "Lively Rural Atmosphere",
    "WhyChoosedescription": "The Hurda Party takes place in open fields or agro-tourism centers surrounded by nature and peacocks. The ambiance includes folk music, puppet shows, and traditional games that immerse visitors in the vibrant village lifestyle."
  },
  {
    "WhyChooseheading": "Family-Friendly Festivities",
    "WhyChoosedescription": "Perfect for families and groups, the party features activities like bullock cart rides, tractor tours, adventure games, and cultural programs. Children and adults alike can enjoy the fun, learning, and togetherness that define this rural celebration."
  },
  {
    "WhyChooseheading": "Scenic Agro-Tourism Locations",
    "WhyChoosedescription": "Hosted at popular agro-tourism spots like Anand Krushi Paryatan Kendra and Mhalasakant Agritourism, the Hurda Party combines traditional festivities with modern amenities such as swimming pools, rain dance, and comfortable dining."
  },
  {
    "WhyChooseheading": "Affordable and Inclusive Packages",
    "WhyChoosedescription": "Visitors can choose from budget-friendly packages that include meals, entertainment, and all activities. This makes the Hurda Party an accessible and enjoyable cultural outing for tourists, locals, and corporate groups alike."
  }
]

















    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What is a Hurda Party at Morachi Chincholi?',
    answer: 'A Hurda Party is a traditional winter celebration where tender jowar (sorghum) is roasted and enjoyed with local chutneys, jaggery, and pickles around a bonfire.',
  },
  {
    id: 'FAQ2',
    question: 'When is the best time to attend a Hurda Party in Morachi Chincholi?',
    answer: 'The Hurda Party season is typically from November to February, with peak celebrations in November and December.',
  },
  {
    id: 'FAQ3',
    question: 'What activities can I expect at the Hurda Party?',
    answer: 'Besides enjoying roasted hurda, you can participate in tractor and bullock cart rides, traditional village games, live music, bonfires, rain dance, and farm walks.',
  },
  {
    id: 'FAQ4',
    question: 'Is the Hurda Party suitable for families and children?',
    answer: 'Yes! The event offers fun activities for all age groups, including kids, and a safe, friendly environment for families.',
  },
  {
    id: 'FAQ5',
    question: 'Are meals included in the Hurda Party packages?',
    answer: 'Yes, most packages include breakfast, sugarcane juice, the hurda snack, traditional lunch, and evening high tea or snacks.',
  },
  {
    id: 'FAQ6',
    question: 'Do I need to book in advance for the Hurda Party?',
    answer: 'It is recommended to book in advance, especially on weekends and peak season, as spots fill up quickly.',
  },
  {
    id: 'FAQ7',
    question: 'How do I reach Morachi Chincholi for the Hurda Party?',
    answer: 'Morachi Chincholi is about 65 km from Pune and can be reached by car or taxi via Alandi or Chakan. Self-driving is also convenient.',
  },
  {
    id: 'FAQ8',
    question: 'What should I carry for attending the Hurda Party?',
    answer: 'Carry warm clothes (evenings can be chilly), sunscreen, insect repellent, comfortable shoes, and a camera to capture the moments.',
  },
  {
    id: 'FAQ9',
    question: 'How long does the Hurda Party event last?',
    answer: 'Typically, the event runs from morning till late afternoon or evening, around 9:30 AM to 6 PM, depending on the organizer.',
  },
  {
    id: 'FAQ10',
    question: 'Is the Hurda Party an eco-friendly event?',
    answer: 'Yes, the celebrations follow eco-friendly practices, focusing on natural farm experiences and minimizing environmental impact.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Abhijeet Deshmukh, Pune',
    feedback: "The Hurda Party at Morachi Chincholi was an unforgettable experience! The food was authentic, the bonfire cozy, and the activities kept everyone engaged. Highly recommended!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Joshi, Pune',
    feedback: "Loved the warm vibe of the Hurda Party. It felt like a true village celebration with delicious food and lots of fun games. Perfect winter outing near Pune.",
    rating: 5,
  },
];




















    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hurda Party Morachi Chincholi",
  "image": "https://morachichincholi.in/assets/images/hurda-party-morachi-chincholi.jpg",
  "description": "Experience seasonal hurda parties near Morachi Chincholi with traditional Maharashtrian folk music, rural games, bonfires, organic hurda tasting, and family-friendly farm outings. Enjoy cultural food events and affordable weekend packages.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1580"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "750",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/hurda-party"
  }
};




    return (
        <div>
<Helmet>
  <title>Hurda Party Morachi Chincholi | Traditional Maharashtrian Farm Festivities & Food</title>
  <meta 
    name="description" 
    content="Join seasonal hurda parties near Morachi Chincholi featuring folk music, rural games, bonfires, organic hurda tasting, and family-friendly agro-tourism events. Perfect for cultural food lovers and weekend getaways." 
  />
  <meta 
    name="keywords" 
    content="Seasonal hurda parties near Morachi Chincholi, Farm-based hurda events, Hurda party with folk music, Traditional Maharashtrian hurda experiences, Group hurda parties in Morachi Chincholi, Hurda party with rural games, Family-friendly hurda outings, Bonfire hurda party options, Organic hurda tasting near Pune, Agro-tourism hurda events, Cultural food events in Morachi Chincholi, Weekend hurda trips from Pune, Hurda party with kids activities, Affordable hurda party packages, Farm picnic with hurda theme" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Hurdapartymorachichincholi;